import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const stepLineWidth = '2px';

export const stepper = css`
  display: flex;

  .stepper {
    min-width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .step {
    position: relative;
    width: 100%;
  }

  .step-num {
    position: absolute;
    color: ${theme.colors.primary50};
    background-color: ${theme.colors.white};
    border: 2px solid ${theme.colors.primary50};
    border-radius: 50%;
    width: 24px;
    height: 24px;
    padding: ${stepLineWidth};
    margin-right: ${theme.spacing(3)};
  }

  .line {
    width: ${stepLineWidth};
    position: absolute;
    top: 22px;
    left: 12px;
    bottom: 0;
    background-color: ${theme.colors.primary50};
  }
  .step:last-child .line {
    display: none;
  }
  .step-text {
    margin-left: ${theme.spacing(5)};
    min-height: 48px;
  }
`;
